import { get } from 'axios'

export default {
    actions: {
        async getRoles(ctx, params = {}) {
            if (ctx.state.roles.length) return
            console.time('Load roles time')

            const request = await get('/api/users/findroles')

            const label = `[vuex] [global] Get roles [${request.data.length}]`;
            console.groupCollapsed(label);
            console.info(request.data);
            console.timeEnd('Load roles time')
            console.groupEnd(label);

            ctx.commit('updateRoles', request.data)
        }
    },
    mutations: {
        updateRoles(state, roles) {
            state.roles = roles
        },
    },
    state: {
        roles: [],
    },
    getters: {
        getRoles(state) {
            return state.roles
        },
        getRoleByID(state) {
            return (roleId) => {
                return state.roles.find(f => f.Id === roleId)
            }
        },
    },
}